module.exports = __webpack_public_path__ + "img/RO.aff860a0.png";